import { get } from "lodash";
export const getHeaderBanner = (state) => get(state, "headerBanner");
export const getPages = (state) => get(state, "pages");
export const getGiftCard = (state) => get(state, "giftCard");
export const getHeaderBannerHeight = (state) =>
  get(state, "headerBanner.bannerHeight");
export const getHeaderHeight = (state) =>
  get(state, "headerBanner.headerHeight");
